import { FC, ChangeEvent } from "react";
import { Grid, Typography } from "@mui/material";
import { black } from "@/theme/colors";
import { Button } from "@/components/elements/Button";
import { Combobox } from "@/components/elements/Combobox";
import { TCompanyFilterForm } from "@/features/company/types";
import { TOption } from "@/types/common";
import { Checkbox } from "@/components/elements/Checkbox";
import { DebounceInput } from "@/components/elements/Input/Input";

type Props = {
  formValues: TCompanyFilterForm;
  onChange: (values: TCompanyFilterForm) => void;
  onSubmit: () => void;
  industryOptions: TOption[];
  isIndustryLoading: boolean;
};

export const CompanyFilterForm: FC<Props> = ({ formValues, onChange, onSubmit, industryOptions, isIndustryLoading }) => {
  const isAllEmpty =
    !formValues.keyword && !formValues.companySpecificIndustryId && !formValues.isArchive;

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...formValues,
      isArchive: e.target.checked,
    });
  };

  const handleClear = () => {
    onChange({
      keyword: "",
      companySpecificIndustryId: "",
      isArchive: false,
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={10.5}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography component="p" variant="cap12" color={black[30]} mb={1}>
              管理番号または所属機関名から検索
            </Typography>
            <DebounceInput
              placeholder="入力してください"
              value={formValues.keyword}
              onChange={(e) => onChange({ ...formValues, keyword: e.target.value })}
              size="md"
              style={{ width: "100%" }}
            />
            <Checkbox onChange={handleCheckboxChange} label="アーカイブから検索" checked={formValues.isArchive} />
          </Grid>

          <Grid item xs={6}>
            <Typography component="p" variant="cap12" color={black[30]} mb={1}>
              分野
            </Typography>
            <Combobox
              value={formValues.companySpecificIndustryId ?? ""}
              onChange={(val) => onChange({ ...formValues, companySpecificIndustryId: val as string })}
              options={industryOptions}
              loading={isIndustryLoading}
              isDisabledInput={true}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs spacing={2} alignContent="center">
        <Button size="sm" type="button" variant="text" disabled={isAllEmpty} onClick={handleClear}>
          クリア
        </Button>
        <Button size="sm" type="button" variant="outline" disabled={isAllEmpty} onClick={onSubmit}>
          検索
        </Button>
      </Grid>
    </Grid>
  );
};
